import { ITO } from "@amzn/ito-client";
import { SentryFetchHttpHandler } from "@amzn/sentry-fetch-http-handler";
import { API_BASE_URL } from "configuration/config";
import { AMZNHAM } from "interfaces/constants";

export type ITOConsumer = "itmp" | typeof AMZNHAM;
const proxyMapping: { [key in ITOConsumer]: string } = {
  itmp: "/ito",
  amznham: `/ito-${AMZNHAM}`,
};

export function getITOClient(consumer?: ITOConsumer): { client: ITO; requestHandler: SentryFetchHttpHandler } {
    const requestHandler = new SentryFetchHttpHandler();

    // Use ITMP as default consumer
    consumer = consumer ?? "itmp";

    return {
        client: new ITO({
            endpoint: API_BASE_URL + proxyMapping[consumer],
            region: "*",
            credentials: { accessKeyId: "", secretAccessKey: "" },
            requestHandler: requestHandler,
        }),
        requestHandler: requestHandler,
    };
}